import { t } from 'i18next';
import { getDate, getLocaleDateString } from './DateFormatter';
export const ROW_HEIGHT = 32;
export const ALL_BANK_ACCOUNT = {
  value: '00000000-0000-0000-0000-000000000001',
};
export const UNDEPOSITED_FUNDS = {
  value: '00000000-0000-0000-0000-000000000002',
};

export const formatLabelMap = {
  DOCX: 'Word',
  XLSX: 'Excel',
};

export const connector = '\u200B\u200C\u200D';
export const verySmallString = '\u0000';

export const filenameRegExp = new RegExp(/filename="?([^"]*)"?;/);
export enum ReceiptBankedTypeEnum {
  All,
  Unbanked,
  Banked,
}
export enum MatterFilterBalanceType {
  MattersWithOutstandingBalances,
  MattersWithBalancesAndTransactions,
}
export const getFeeEarnerOverviewSections = () => [
  {
    value: 0,
    label: t('Overview'),
  },
  {
    value: 1,
    label: t('New Clients'),
  },
  {
    value: 2,
    label: t('New Matters'),
  },

  {
    value: 3,
    label: t('Top Clients'),
  },
  {
    value: 4,
    label: t('Top Fees Billed'),
  },
  {
    value: 5,
    label: t('Top Exposure'),
  },
  {
    value: 6,
    label: t('Matters by Matter Type'),
  },
  {
    value: 7,
    label: t('Fees Current FY vs Last FY by Matter'),
  },
  {
    value: 8,
    label: t('Fees Performance Summary FYTD by Matter'),
  },
  {
    value: 9,
    label: t('Fees Current FY vs Last FY recorded for Staff'),
  },
  {
    value: 10,
    label: t('Fees Performance Summary FYTD recorded for Staff'),
  },
  {
    value: 11,
    label: t('Budget Comparison FYTD Record for Staff'),
  },
  {
    value: 12,
    label: t('Top Trust to Office Transfer Availability'),
  },
  {
    value: 13,
    label: t('Top Aged WIP Recorded for Staff'),
  },
  {
    value: 14,
    label: t('Top Aged WIP by Matter'),
  },
  {
    value: 15,
    label: t('Top Aged Disbursements by Matter'),
  },
  {
    value: 16,
    label: t('Top Aged Debtors by Matter'),
  },
  {
    value: 17,
    label: t('Top Controlled Money Balance'),
  },
];

export const getFirmOverviewSections = () => [
  {
    value: 0,
    label: t('Overview'),
  },
  {
    value: 1,
    label: t('Matters by Matter Type'),
  },
  {
    value: 2,
    label: t('Top 10 Clients'),
  },
  {
    value: 3,
    label: t('Top 10 Exposure'),
  },
  {
    value: 4,
    label: t('Fees Current FY vs Last FY'),
  },
  {
    value: 5,
    label: t('Fees Performance Summary FYTD'),
  },
  {
    value: 6,
    label: t('Fee Earner Summary'),
  },

  {
    value: 7,
    label: t('TopTrustToOfficeTransfer', { selectTop: 10 }),
  },
  {
    value: 8,
    label: t('Ageing Summary'),
  },
  {
    value: 9,
    label: t('Top 10 Controlled Money'),
  },
];

export const getStaffTypeList = () => [
  {
    value: '1',
    label: t('Staff Responsible'),
    isDefault: true,
  },
  {
    value: '2',
    label: t('Staff Acting'),
  },
  {
    value: '3',
    label: t('Staff Credit'),
  },
];

export const getFeeEarnerSummaryStaffTypeList = () => [
  {
    value: '0',
    label: t('Staff'),
    isDefault: true,
  },
  {
    value: '1',
    label: t('Staff Responsible'),
  },
  {
    value: '2',
    label: t('Staff Acting'),
  },
  {
    value: '4',
    label: t('Staff Assisting'),
  },
  {
    value: '3',
    label: t('Staff Credit'),
  },
];
export const getFeeEarnerSummaryAttributeList = () => [
  {
    value: 1,
    label: t('Staff Responsible'),
    isDefault: true,
  },
  {
    value: 2,
    label: t('Staff Acting'),
  },

  {
    value: 3,
    label: t('Staff Credit'),
  },
  {
    value: 4,
    label: t('Staff Assisting'),
  },
];
export const getPeriodList = () => [
  {
    value: 'Quarter',
    label: t('Quarter'),
  },
  {
    value: 'Month',
    label: t('Month'),
    isDefault: true,
  },
  {
    value: 'Annual',
    label: t('Annual'),
  },
];

export const getMonthList = (type: 'long' | 'short' = 'short') => {
  const date = getDate();
  const currentMonth = date.month();
  const arr = new Array(12).fill(undefined);
  return arr.map((item, index) => {
    date.set('month', index);
    // short: Jan,
    // long: January
    return {
      label: getLocaleDateString(date, { month: type }),
      value: index + 1,
      isDefault: currentMonth === index,
    };
  });
};

export const getDisbursementTypeList = () => [
  {
    value: '1',
    label: t('Anticipated Payments'),
  },
  {
    value: '3',
    label: t('Cost Recoveries'),
  },
  { value: '2', label: t('Journals') },
  {
    value: '0',
    label: t('Payments'),
  },
];

export const getDisbursementExpandOptions = () => [
  {
    value: 'MatterTotalsOnly',
    label: t('Matter totals only'),
    isDefault: true,
  },
  {
    value: 'MatterAndItemTotals',
    label: t('Matter and type totals'),
  },
  {
    value: 'MatterAndItemTotalsWithTransactions',
    label: t('Matter and type totals with transactions'),
  },
];
export const getStaffReceiptedFundsExpandOptions = () => [
  {
    value: 'None',
    label: t('None'),
  },
  {
    value: 'Staff',
    label: t('Staff'),
  },
  {
    value: 'Invoices',
    label: t('Receipts'),
  },
];

export const getAllStaffTypeList = () => [
  {
    value: 'StaffResponsible',
    label: t('Staff Responsible'),
  },
  {
    value: 'StaffActing',
    label: t('Staff Acting'),
  },
  {
    value: 'StaffAssisting',
    label: t('Staff Assisting'),
  },
  {
    value: 'StaffCredit',
    label: t('Staff Credit'),
  },
  {
    value: 'Staff',
    label: t('Staff'),
  },
];

export const getMatterBalanceTypeList = () => [
  {
    value: MatterFilterBalanceType[0],
    label: t('With outstanding balances'),
    isDefault: true,
  },
  {
    value: MatterFilterBalanceType[1],
    label: t('With balances and/or transactions'),
  },
];

export const countryCodeLocaleMap = {
  0: 'au',
  1: 'uk',
  2: 'us',
  3: 'ca',
  4: 'ie',
  5: 'nz',
};

export const linkMaps = {
  au: {
    helpCenterUrl: 'https://community.leap.com.au/s/',
    powerBILink: 'https://community.leap.com.au/s/article/Installing-Power-BI-LEAP-Connector-AU',
    articleLinks: [
      {
        label: 'Available LEAP Reports',
        link: 'https://community.leap.com.au/s/article/Available-LEAP-reports',
      },
      {
        label: 'About LEAP Reports',
        link: 'https://community.leap.com.au/s/article/About-LEAP-Reports',
      },
      {
        label: '10 Essential LEAP Reports',
        link: 'https://community.leap.com.au/s/article/10-Essential-LEAP-Reports-AU',
      },
      // {
      //   label: 'A Guide on Invoice-Related Reports',
      //   link: 'https://community.leap.com.au/s/article/A-Guide-on-Invoices-Related-Reports-AU',
      // },
      {
        label: 'LEAP Reports - FAQs',
        link: 'https://community.leap.com.au/s/article/LEAP-Reports-FAQs-AU',
      },
    ],
  },
  nz: {
    helpCenterUrl: 'https://help.leaplegalsoftware.co.nz/s/',
    powerBILink: 'https://help.leaplegalsoftware.co.nz/s/article/Installing-Power-BI-LEAP-Connector-NZ',
    articleLinks: [
      {
        label: 'Available LEAP Reports',
        link: 'https://help.leaplegalsoftware.co.nz/s/article/Available-LEAP-Reports-NZ',
      },
      {
        label: 'LEAP Reports: Overview and Functional Guide',
        link: 'https://help.leaplegalsoftware.co.nz/s/article/About-LEAP-Reports-NZ',
      },
      {
        label: '10 Essential LEAP Reports',
        link: 'https://help.leaplegalsoftware.co.nz/s/article/10-Essential-LEAP-Reports-NZ',
      },
      // {
      //   label: 'A Guide on Invoice-Related Reports',
      //   link: 'https://help.leaplegalsoftware.co.nz/s/article/A-Guide-on-Invoice-Related-Reports-NZ',
      // },
      {
        label: 'LEAP Reports - FAQs',
        link: 'https://help.leaplegalsoftware.co.nz/s/article/LEAP-Reports-FAQs-NZ',
      },
    ],
  },
  ca: {
    helpCenterUrl: 'https://help.leaplegalsoftware.ca/s/',
    powerBILink: 'https://help.leaplegalsoftware.ca/s/article/Installing-Power-BI-LEAP-Connector-CA',
    articleLinks: [
      {
        label: 'Available LEAP Reports',
        link: 'https://help.leaplegalsoftware.ca/s/article/Available-LEAP-Reports-CA',
      },
      {
        label: 'About LEAP Reports',
        link: 'https://help.leaplegalsoftware.ca/s/article/About-LEAP-Reports-CA',
      },
      {
        label: '10 Essential LEAP Reports',
        link: 'https://help.leaplegalsoftware.ca/s/article/10-Essential-LEAP-Reports-CA',
      },
      // {
      //   label: 'A Guide on Invoice-Related Reports',
      //   link: 'https://help.leaplegalsoftware.ca/s/article/A-Guide-on-Invoice-Related-Reports-CA',
      // },
      {
        label: 'LEAP Reports - FAQs',
        link: 'https://help.leaplegalsoftware.ca/s/article/LEAP-Reports-FAQs-CA',
      },
    ],
  },
  us: {
    helpCenterUrl: 'https://community.leap.us/s/',
    powerBILink: 'https://community.leap.us/s/article/Installing-Power-BI-LEAP-Connector-US',
    articleLinks: [
      {
        label: 'Available LEAP Reports',
        link: 'https://community.leap.us/s/article/Available-LEAP-Reports-US',
      },
      {
        label: 'About LEAP Reports',
        link: 'https://community.leap.us/s/article/Access-Reports',
      },
      {
        label: '10 Essential LEAP Reports',
        link: 'https://community.leap.us/s/article/10-Essential-LEAP-Reports-US',
      },
      // {
      //   label: 'A Guide on Invoice-Related Reports',
      //   link: 'https://community.leap.us/s/article/A-Guide-On-Invoice-Related-Report-US',
      // },
      {
        label: 'LEAP Reports - FAQs',
        link: 'https://community.leap.us/s/article/LEAP-Reports-FAQs-US',
      },
    ],
  },
  uk: {
    helpCenterUrl: 'https://community.leap.co.uk/s/',
    powerBILink: 'https://community.leap.co.uk/s/article/Installing-Power-BI-LEAP-Connector-UK',
    articleLinks: [
      {
        label: 'Available LEAP Reports',
        link: 'https://community.leap.co.uk/s/article/Available-LEAP-Reports-UK',
      },
      {
        label: 'About LEAP Reports',
        link: 'https://community.leap.co.uk/s/article/LEAP-Reports-UK',
      },
      {
        label: '10 Essential LEAP Reports',
        link: 'https://community.leap.co.uk/s/article/10-Essential-LEAP-Reports-UK',
      },
      // {
      //   label: 'A Guide on Invoice-Related Reports',
      //   link: 'https://community.leap.co.uk/s/article/A-Guide-on-Invoices-Related-Reports-UK',
      // },
      {
        label: 'LEAP Reports - FAQs',
        link: 'https://community.leap.co.uk/s/article/LEAP-Reports-FAQs-UK',
      },
    ],
  },
};
